import PageLayout from '@ui/templates/page-template/page-layout';
import styled from 'styled-components';
import {Controller} from 'react-hook-form';
import {Label} from '@ui/atoms/label';

import {VerticalSpacer} from '@ui/atoms/spacer';
import {observer} from 'mobx-react-lite';
import {TextField} from '@ui/molecules/field/textfield';
import {Button} from '@ui/atoms/button';
import {UserSelectField} from '@ui/molecules/select/user';
import useRequestFeedback from './request-feedback-hook';
import {useNavigate} from 'react-router';

const FormWrapper = styled.div<{$embedded?: boolean}>`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .form {
    width: ${({$embedded}) => ($embedded ? '100%' : '40%')};
    max-width: 100%;
    min-width: 0;

    margin-bottom: 30px;

    form {
      width: 100%;
      max-width: 100%;
      min-width: 0;
    }

    form > label:not(:first-child) {
      margin-top: 24px;
    }
    @media (min-width: 1100px) and (max-width: 1320px) {
      width: ${({$embedded}) => ($embedded ? '100%' : '40%')};
    }
    @media (min-width: 768px) and (max-width: 1100px) {
      width: ${({$embedded}) => ($embedded ? '100%' : '70%')};
    }
    @media (max-width: 768px) {
      width: 100%;
    }
  }
`;
interface RequestFeedbackProps {
  embedded?: boolean;
  onSuccess?: () => void | Promise<void>;
}

const RequestFeedback = ({embedded, onSuccess}: RequestFeedbackProps) => {
  const navigate = useNavigate();
  const {
    handleFormValueChange,
    users,
    isSubmitting,
    errors,
    handleSubmit,
    onSubmit,
    isDisabled,
    control,
  } = useRequestFeedback({onSuccess});

  const content = (
    <FormWrapper $embedded={embedded}>
      <div className="form">
        <form action="" onSubmit={handleSubmit(onSubmit)}>
          <Label>Recipient</Label>
          <VerticalSpacer size="8px" />
          <Controller
            control={control}
            name="user"
            render={({onBlur, value}) => (
              <UserSelectField
                onBlur={onBlur}
                name="user"
                value={value}
                helper={errors.user?.message || ''}
                state={errors.user ? 'error' : 'default'}
                onChange={(data: {value: string}) =>
                  handleFormValueChange(data.value, 'user')
                }
                placeholder="Select member"
                options={users}
                fieldNotFoundPlaceHolder={(searchTerm?: string) =>
                  `Oops! Seems there is no ${searchTerm} found in this workspace`
                }
              />
            )}
          />
          <Label>Topic</Label>
          <VerticalSpacer size="8px" />
          <Controller
            control={control}
            name="subjectName"
            render={({onBlur, onChange, value}) => (
              <TextField
                helper={errors.subjectName?.message || ''}
                maxLength={120}
                state={errors.subjectName ? 'error' : 'default'}
                multiple
                autoResize
                minTextareaHeight={52}
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                placeholder="Enter a topic or question"
                inputStyle={{
                  borderRadius: 10,
                  height: '52px',
                  minHeight: '52px',
                  padding: '12px 14px',
                }}
              />
            )}
          />

          <VerticalSpacer size="16px" />
          <Button
            width="full"
            type="submit"
            data-form-action={true}
            isLoading={isSubmitting}
            disabled={isSubmitting || isDisabled}
            aria-busy={isSubmitting}>
            Request feedback
          </Button>
        </form>
      </div>
    </FormWrapper>
  );

  if (embedded) return content;

  return (
    <PageLayout
      title="Request feedback"
      guideUrl="https://peoplebeam.myhcpage.com/en-us/"
      onClick={() => navigate(-1)}>
      {content}
    </PageLayout>
  );
};
export default observer(RequestFeedback);
